import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PoliceCreationFileUpload } from '../welcome/home-menu/bancassurance-services/service-client/police-form/index.dto';
import { catchError, map } from 'rxjs/operators';
import { getHeaderEdition, getHeaders } from '../utils/correlationId';

@Injectable({
  providedIn: 'root'
})
export class BankAssuranceService {



  // Le constructeur ne demande plus HttpHeaders !
  constructor(private http: HttpClient) {

  }

  /**
   * Génère un ID de corrélation unique pour une opération.
   * Note : crypto.randomUUID() est souvent préféré, mais votre méthode fonctionne.
   */


  /**
   * Crée les headers juste avant d'envoyer la requête.
   * Cela garantit que le Correlation ID est frais pour chaque appel.
   */



  // Exemple d'une méthode qui utilise les headers
  /*public createPolicy(policyData: any): Observable<any> {
    const headers = getHeaders();
    console.log('Sending request with Correlation-ID:', headers.get('X-Correlation-ID'));
    return this.http.post(this.apiUrl, policyData, { headers: headers });
  }*/

  private policyIDSubject = new BehaviorSubject<string | null>(null);
  policyID$ = this.policyIDSubject.asObservable();

  setPolicyID(id: string) {
    this.policyIDSubject.next(id);
  }

  getPolicyID() {
    return this.policyIDSubject.value;
  }


  getMedicalDocuments(bankId: string, amount: number, age: number, token: string): Observable<any[]> {
    console.log(`getMedicalDocuments called with bankId=${bankId}, amount=${amount}, age=${age}`);
    const url = `${environment.MSAggravation}/api/bank/${bankId}/MedicalTarificationDocument/documents/amount/${amount}/${age}`;
    //const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const headers = getHeaders();
    return this.http.get<any[]>(url, { headers, params: { token: token } });
  }

   getProduceurEmail(token: string) {
    const url = `${environment.MSBank}/api/ProducerEmail/Get`;
    //const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const headers = getHeaders();
    //return this.http.get<any>(url, { headers, params: { token: token } });
    return this.http.get(`${environment.MSBank}/api/ProducerEmail/Get`, { headers, params: { token: token } });

  }


  // Subscription contract
  souscriptionPolice(data: any, token): Observable<any> {
    console.log(data);
    const headers = getHeaders();
    return this.http.post(`${environment.MSPolicy}/api/Police/CreatePolicy`, data, { headers, params: { token: token } });
    //return console.log(data);
  }

  invalidatePolicy2(token: string, id: string, reasonOfReject: string): Observable<any> {
    const headers = getHeaders();
    return this.http.put(
      `${environment.MSPolicy}/api/Police/${id}/inValidate`,
      {},
      { headers, params: { token, reason: reasonOfReject } }
    );
  }

  // Ajouter une nouvelle assurance bancaire /api/Police/SavePolicy
  createBankAssurance(data: any, token): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSPolicy}/api/Police/CreatePolicy`, data, { headers, params: { token: token } });
  }

  // recherchez by name
  searchAssureByName(searchCriteria: any, token: string): Observable<any> {
    // Construction des paramètres pour une requête GET
    const bankId = localStorage.getItem('ACTIVA_REDACTEUR_BANkID');
    let params = new HttpParams();
    params = params.set('token', token);
    // Ajout du paramètre name obligatoire
    if (searchCriteria.nom_prenom) {
      params = params.set('name', searchCriteria.nom_prenom);
      params = params.set('bankId', bankId);
    }

    const headers = getHeaders();
    // Requête GET avec les paramètres
    return this.http.get<any>(`${environment.MSPolicy}/api/Person/SearchPersons`, { headers, params: params });
  }

  SavePolicyOLD(data: any, token): Observable<any> {
    console.log("SavePolicy")
    console.log(data)
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSPolicy}/api/Police/SavePolicy`, data, { headers, params: { token: token } });
  }

  Authenticate(data: any, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSBank}/api/Police/SavePolicy`, data, { headers, params: { token: token } });
  }

  getAllPolicies(token: string) {
    const headers = getHeaders();

    return this.http.get(`${environment.MSPolicy}/api/Police/GetAllPolicies`, { headers, params: { token: token } });
  }

  getAllAgences() {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/Branch/Get`, { headers, params: { token: environment.tokem_bank } });
  }

  /**
   * Récupère la liste des banques depuis l'API Bank/Get
   */
  getBanks(token: string) {
    const headers = getHeaders();
    const params = { token };
    return this.http.get<any>(`${environment.MSBank}/api/Bank/Get`, { headers, params });
  }

  deletePolicy(id: any, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.delete<any>(`${environment.MSPolicy}/api/Police/CancelPolicy/${id}`, { headers, params: { token: token } });
  }

  getAllPoliciesFilter2(data: any, token: string): Observable<any[]> {
    const params: any = {
      token: token,
      ...data // Spread operator to include all `data` properties as query parameters
    };

    const headers = getHeaders();
    return this.http.get<any[]>(`${environment.MSPolicy}/api/Police/GetPolicesFilter`, { headers, params });
  }

  impression1(payload: any): Observable<{ downloadUrl: string }> {
    // const url = 'https://localhost:44323/api/Reports/generate';
    // var url = this.editingTemplateUrl;
    const headers = getHeaders();

    return this.http.post<{ downloadUrl: string }>(`${environment.MsUpload}/api/Report/generate`, payload, { headers });
  }
  impression(payload: any): Observable<{ downloadUrl: string }> {
    const params: any = {
      token: payload.token,

    };
    const headers = getHeaders();
    return this.http.post<{ downloadUrl: string }>(`${environment.MsUpload}/api/Report/generate`, payload, { headers, params });
  }
  downloadPdfWithHeaders(downloadPath: string): Observable<Blob> {
    // Créez vos en-têtes. Remplacez 'VOTRE_TOKEN_ICI' par votre vrai token JWT.
    const headers = getHeaders();

    const fullUrl = `${environment.MsUpload}/api/Report/${downloadPath}`;

    // Effectuez la requête GET en spécifiant que la réponse est un 'blob'
    return this.http.get(fullUrl, {
      headers: headers,
      responseType: 'blob'
    });
  }
  // getAllPoliciesFilter(
  //   date_minimum?: string,
  //   date_maximum?: string,

  //   policyStatus?: string,  // Ajout du paramètre policyStatus
  //   productCode?: string,
  //   userWhoNew?: string,
  //   agencyCode?: string,
  //   groupPolicyID?: string,
  //   insuredName?: string,
  //   customerID?: number,

  //   token?: string
  // ): Observable<any[]> {
  //   let params = new HttpParams();

  //   if (date_minimum) params = params.set('date_minimum', date_minimum);
  //   if (date_maximum) params = params.set('date_maximum', date_maximum);
  //   if (userWhoNew) params = params.set('userWhoCreated', userWhoNew);
  //   if (productCode) params = params.set('productCode', productCode);
  //   if (policyStatus) params = params.set('policyStatus', policyStatus);
  //   if (agencyCode) params = params.set('agencyCode', agencyCode);
  //   if (groupPolicyID) params = params.set('groupPolicyID', groupPolicyID);
  //   if (insuredName) params = params.set('insuredname', insuredName);
  //   // if (customerID) params = params.set('customerID', customerID);
  //   params = params.set('token', token);
  //   console.log('params : ')
  //   console.log(params)

  //   return this.http.get<any[]>(`${environment.MSPolicy}/api/Police/GetPolicesFilter`, { params });
  // }

  getAllPoliciesFilter(
    date_minimum?: string,
    date_maximum?: string,
    policyStatus?: string,
    productCode?: string,
    userWhoNew?: string,
    agencyCode?: string,
    groupPolicyID?: string,
    groupContractID?: string, // <--- AJOUT DU PARAMÈTRE groupContractID
    insuredName?: string,
    customerID?: number,
    contractNumberManual?: string,
    contractNumberExternal?: string,
    policeHeliosID?: number,
    pageNumber?: number,
    pageSize?: number,
    token?: string
  ): Observable<any> { // <--- CORRECTION CRUCIALE ICI: any[] devient any
    let params = new HttpParams();

    if (date_minimum) params = params.set('date_minimum', date_minimum);
    if (date_maximum) params = params.set('date_maximum', date_maximum);
    params = params.set('token', token);
    if (userWhoNew) params = params.set('userWhoCreated', userWhoNew);
    if (productCode) params = params.set('productCode', productCode);
    if (policyStatus) params = params.set('policyStatus', policyStatus);
    if (agencyCode) params = params.set('agencyCode', agencyCode);
    if (groupPolicyID) params = params.set('groupPolicyID', groupPolicyID);
    if (groupContractID) params = params.set('groupContractID', groupContractID); // <--- AJOUT DU PARAMÈTRE groupContractID
    if (insuredName) params = params.set('insuredname', insuredName);
    if (pageNumber > 0) params = params.set('pageNumber', pageNumber.toString());
    if (contractNumberManual) params = params.set('contractNumberManual', contractNumberManual);
    if (contractNumberExternal) params = params.set('contractNumberExternal', contractNumberExternal);
    if (policeHeliosID) params = params.set('policeHeliosID', policeHeliosID.toString());
    if (pageSize > 0) params = params.set('pageSize', pageSize.toString());

    if (customerID) params = params.set('customerID', customerID.toString());

    console.log('params : ')
    console.log(params);
    console.log(pageSize);

    // Le type de retour de la requête GET est maintenant <any> pour correspondre à la fonction
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSPolicy}/api/Police/GetPolicesFilter`, { headers, params });
  }

  getAllPoliciesFilterNew(
    filterData: any, // On passe un seul objet contenant tous les filtres
    pageNumber: number,
    pageSize: number,
    token: string
  ): Observable<any> {

    let params = new HttpParams();

    // On ajoute les paramètres seulement s'ils ont une valeur.
    // C'est plus propre et évite d'envoyer des paramètres vides.
    if (filterData.date_minimum) params = params.set('date_minimum', filterData.date_minimum);
    if (filterData.date_maximum) params = params.set('date_maximum', filterData.date_maximum);
    if (filterData.policyStatus) params = params.set('policyStatus', filterData.policyStatus);
    if (filterData.groupPolicyID) params = params.set('productCode', filterData.groupPolicyID); // Note: le backend attend 'productCode'
    if (filterData.userWhoCreated) params = params.set('userWhoCreated', filterData.userWhoCreated);
    if (filterData.agencyCode) params = params.set('agencyCode', filterData.agencyCode);
    if (filterData.customerID) params = params.set('customerID', filterData.customerID.toString());
    if (filterData.contractNumberManual) params = params.set('contractNumberManual', filterData.contractNumberManual);

    // AJOUT DES PARAMÈTRES MANQUANTS
    if (filterData.contractNumberExternal) params = params.set('contractNumberExternal', filterData.contractNumberExternal);
    if (filterData.policeHeliosID) params = params.set('policeHeliosID', filterData.policeHeliosID.toString());

    // Ajout des paramètres de pagination
    if (pageNumber) params = params.set('pageNumber', pageNumber.toString());
    if (pageSize) params = params.set('pageSize', pageSize.toString());

    // Ajout du token
    params = params.set('token', token);

    const headers = getHeaders();
    console.log('Params envoyés à l\'API:', params.toString());

    return this.http.get<any>(`${environment.MSPolicy}/api/Police/GetPolicesFilter`, { headers, params });
  }

  getAllPoliciesFilterNewClaim(
    filterData: any, // On passe un seul objet contenant tous les filtres
    pageNumber: number,
    pageSize: number,
    token: string
  ): Observable<any> {

    let params = new HttpParams();

    // On ajoute les paramètres seulement s'ils ont une valeur.
    // C'est plus propre et évite d'envoyer des paramètres vides.
    if (filterData.date_minimum) params = params.set('date_minimum', filterData.date_minimum);
    if (filterData.date_maximum) params = params.set('date_maximum', filterData.date_maximum);
    if (filterData.policyStatus) params = params.set('policyStatus', filterData.policyStatus);
    if (filterData.groupPolicyID) params = params.set('productCode', filterData.groupPolicyID); // Note: le backend attend 'productCode'
    if (filterData.userWhoCreated) params = params.set('userWhoCreated', filterData.userWhoCreated);
    if (filterData.agencyCode) params = params.set('agencyCode', filterData.agencyCode);
    if (filterData.customerID) params = params.set('customerID', filterData.customerID.toString());
    if (filterData.contractNumberManual) params = params.set('contractNumberManual', filterData.contractNumberManual);

    // AJOUT DES PARAMÈTRES MANQUANTS
    if (filterData.contractNumberExternal) params = params.set('contractNumberExternal', filterData.contractNumberExternal);
    if (filterData.policeHeliosID) params = params.set('policeHeliosID', filterData.policeHeliosID.toString());

    // Paramètres de recherche par assuré
    if (filterData.insuredFirstName) params = params.set('insuredFirstName', filterData.insuredFirstName);
    if (filterData.insuredLastName) params = params.set('insuredLastName', filterData.insuredLastName);
    if (filterData.birthPlace) params = params.set('birthPlace', filterData.birthPlace);
    if (filterData.birthDate) params = params.set('birthDate', filterData.birthDate);

    // Ajout des paramètres de pagination
    if (pageNumber) params = params.set('pageNumber', pageNumber.toString());
    if (pageSize) params = params.set('pageSize', pageSize.toString());

    // Ajout du token
    params = params.set('token', token);

    const headers = getHeaders();
    console.log('Params envoyés à l\'API:', params.toString());

    return this.http.get<any>(`${environment.MSClaim}/api/claims/police/data`, { headers, params });
  }




  getAllProducts(token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSPolicy}/api/GroupProduct/GetAllGroupProducts`, {
      headers,
      params: { token: token }
    });
  }

  getAllBankGroupProducts(token, id): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/GroupContract/GetBy/Bank/${id}`, {
      headers,
      params: { token: token }
    });
  }
  

  getAllBankProducts(token, id): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/Product/Details/${id}`, {
      headers,
      params: { token: token }
    });
  }

  getAllMiniBankProducts(token, id): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/Product/By/Bank/${id}`, {
      headers,
      params: { token: token }
    });
  }

  getAllBankCoveragesByProduct(token, id): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/Product/GetCoveragesBy/${id}`, {
      headers,
      params: { token: token }
    });
  }

  authenticate(userId: number): Observable<any> {
    if (!environment.bancassurance_api_username || !environment.bancassurance_api_password) {
      return throwError(() => new Error('API credentials are not configured'));
    }

    const body = {
      appUserName: environment.bancassurance_api_username,
      appUserPassword: environment.bancassurance_api_password,
      userId
    };

    const headers = getHeaders();
    console.log("ba-b-body", body);

    return this.http.post(`${environment.MSBank}/api/AppUser/Authenticate`, body, {
      headers
    })
      .pipe(
        map((response: any) => {
          // Store macroPermissions in cookies if they exist
          console.log('Authentication response:', response);
          if (response && response.macroPermissions && Array.isArray(response.macroPermissions)) {
            console.log('Storing macroPermissions in cookie:', response.macroPermissions);
            const macroPermissionsJson = JSON.stringify(response.macroPermissions);
            // Set cookie with 7 days expiration
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 7);
            const cookieValue = `macroPermissions=${encodeURIComponent(macroPermissionsJson)}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
            console.log('Setting cookie:', cookieValue);
            document.cookie = cookieValue;
            console.log('Cookie set. Current cookies:', document.cookie);
          } else {
            console.log('No macroPermissions found in response or response is invalid');
          }
          return response;
        }),
        catchError(error => {
          console.error('Authentication error:', error);
          return throwError(() => error);
        })
      );
  }

  getAllBanks(token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSBank}/api/Bank/Get`, { headers, params: { token } });
  }



  // Get referential data
  getAllDatas(token: string) {
    const headers = getHeaders();
    return this.http.get(`${environment.MSPolicy}/api/v1/SouscriptionGUI/ReferentialData`, { headers, params: { token } });
  }

  // Subscription contract
  generateBearerToken() {
    const headers = getHeaders();
    return this.http.post(`${environment.MSPolicy}/api/v1/Authentication/Authenticate`, {
      "userId": `${environment.autoAuthApiUser}`,
      "password": `${environment.autoAuthApiPassword}`
    }, { headers });
  }



  uploadFiles(formData: any): Observable<any> {
    // Note: Pour les uploads de fichiers, on ne met pas Content-Type car le navigateur le gère automatiquement
    const headers = getHeaderEdition();
    return this.http.post<any>(`${environment.MsUpload}/api/Files/upload`, formData, { headers })
  }
  deleteFile(blobName: string): Observable<any> {
    const headers = getHeaders();
    return this.http.delete<any>(`https://localhost:44323/api/Files/${blobName}`, { headers });
  }

  getAllData(token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.subscriptionBaseUrl}/api/v1/SouscriptionGUI/ReferentialData`, {
      headers,
      params: { token: token } // Assurez-vous que la clé 'token' est correcte
    });
  }



  CreatePerson(data: any, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSPolicy}/api/Person/CreatePerson`, data, { headers, params: { token } });
  }

  SaveSanteResponse(data: any, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSAggravation}/api/Evaluation/${data.UserId}/${data.ManualNumber}/${data.BankId}`, data.Answers, { headers, params: { token } });
  }

  GetSanteResponseHTML(UserId: any, ManualNumber: any, BankId: any, token): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSAggravation}/api/Evaluation/saved-answers/${UserId}/${ManualNumber}/${BankId}`, { headers, params: { token: token }, responseType: 'text' as 'json' });
  }

  GetSanteResponse(UserId: any, ManualNumber: any, BankId: any, token): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSAggravation}/api/Evaluation/${ManualNumber}/${BankId}`, { headers, params: { token: token } });
  }

  GetPoliceById(id: any, token): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSPolicy}/api/Police/GetPolicy/${id}`, { headers, params: { token: token } });
  }

  SearchOnePerson(firstName: string, lastName: string, birthDate: string, personIndice: string, token: string): Observable<any> {
    const headers = getHeaders();
    // L'API attend une date au format MM/DD/YYYY, il faut la formater
    const formattedBirthDate = new Date(birthDate).toLocaleDateString('en-US'); // Format MM/DD/YYYY

    let params = new HttpParams()
      .set('firstName', firstName)
      .set('lastName', lastName)
      .set('birthDate', formattedBirthDate)
      .set('personIndice', personIndice)
      .set('token', token);

    return this.http.get<any>(`${environment.MSPolicy}/api/Person/SearchOnePerson`, { headers, params });
  }

  GetAgency(token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSBank}/api/Branch/Get`, { headers, params: { token: token } });
  }

  GetAgencyById(id: number, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSBank}/api/Branch/GetByBank/${id}`, { headers, params: { token: token } });
  }

  /**
   * Récupère les réponses sauvegardées du questionnaire (HTML) pour une personne en banque
   * URL APIM: /agravation/api/Evaluation/saved-answers/{bankPersonID}/{ManualNumber}/{BankId}
   * Retourne du HTML (responseType: 'text')
   */
  getSavedAnswers(bankPersonID: string, manualNumber: string, bankId: number, token?: string): Observable<string> {
    const headers = getHeaders();
    const url = `${environment.MSAggravation}/api/Evaluation/saved-answers/${bankPersonID}/${manualNumber}/${bankId}`;
    let params = new HttpParams();
    if (token) {
      params = params.set('token', token);
    }
    return this.http.get(url, { headers, params, responseType: 'text' });
  }

  // Wrapper to call the external APIM Branch/Get endpoint with proper headers and correlation id
  getBranchesFromApim(token: string): Observable<any> {
    const headers = getHeaders();
    const params = new HttpParams().set('token', token);
    const url = `${environment.MSBank}/api/Branch/Get`;
    return this.http.get<any>(url, { headers, params });
  }

  // Wrapper to call the external APIM Bank/Get endpoint with proper headers
  getBanksFromApim(token: string): Observable<any> {
    const headers = getHeaders();
    const params = new HttpParams().set('token', token);
    const url = `${environment.MSBank}/api/Bank/Get`;
    return this.http.get<any>(url, { headers, params });
  }

  // Wrapper to call the external APIM Branch/GetByBank/{bankId} endpoint
  getBranchesByBankFromApim(token: string, bankId: number): Observable<any> {
    const headers = getHeaders();
    const params = new HttpParams().set('token', token);
    const url = `${environment.MSBank}/api/Branch/GetByBank/${bankId}`;
    return this.http.get<any>(url, { headers, params });
  }

  GetBank(id: any, token): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSBank}/api/Bank/Get/${id}`, { headers, params: { token: token } });
  }

  EvaluateBankPolicyValue2(data: any,): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.api_tarification}/crm/bankPolicy/evaluateBankPolicyValue`, data, { headers });
  }
  EvaluateBankPolicyValue(data: any, token: string): Observable<any> {
    // return this.http.post<any>(`${environment.api_tarification}/crm/bankPolicy/EvaluateBankPolicyValueNew`, data, { params: { token } });
    const headers = getHeaders();
    return this.http.post<any>(`${environment.api_tarification}/api/Helios/evaluateBankPolicyValue`, data, { headers, params: { token } });
  }

  EvaluateBankPolicyValueCMR(data: any): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`http://heliosapi.group-activa.com/WeliosCMRTest/crm/bankPolicy/evaluateBankPolicyValue`, data, { headers });
  }
  validateUserWelios(data: any): Observable<any> {
    // return this.http.post<any>('https://localhost:44391/Welios/security/user/validateUser', data)
    // return this.http.post<any>('https://bancassurance-dev.group-activa.com/gui/Welios/security/user/validateUser', data) !!
    // return this.http.post<any>('https://apiheliosgn.group-activa.com/Welios/security/user/validateUser', data)
    const headers = getHeaders();
    return this.http.post<any>(`${environment.api_tarification}/security/user/ValidateApiUser`, data, { headers })
  }

  EvaluateBankPolicyValue3(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'   // JSON
    });

    return this.http.post<any>(
      `https://apiheliosgn.group-activa.com/Welios/crm/bankPolicy/evaluateBankPolicyValue`,
      data,
      { headers }
    );
  }

  validatePolicy(token: string, id: string): Observable<any> {
    const headers = getHeaders();
    return this.http.put(
      `${environment.MSPolicy}/api/Police/${id}/Validate`, {}, { headers, params: { token: environment.tokenBankAssurance } });
  }

  invalidatePolicy(token: string, id: string, reasonOfReject: string): Observable<any> {
    // Pass reason as a query parameter instead of in the body
    const headers = getHeaders();
    return this.http.put(
      `${environment.MSPolicy}/api/Police/${id}/inValidate`,
      {}, // Empty body
      { headers, params: { token: token, reason: reasonOfReject } }
    );
  }

  getUrlById(token, id: any): Observable<any> {
    const headers = getHeaders();
    return this.http.get<any>(`${environment.MSBank}/api/EditingTemplate/GetById/${id}`, { headers, params: { token: token } }); // HttpHeaders:{"X-Correlation-ID" :"74feb0c153a14d86baf224b9aab04a4a"}); // Ajout de l'en-tête X-Correlation-ID
  }

  evaluateAgravation(data: any, token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSAggravation}/api/Evaluation/${data.ProductId}/${data.Dob}/${data.LoanDuration}/${data.TypeCapitaux}/${data.isDeferred}`, data.reponsesFormattees, { headers, params: { token: token } }); // HttpHeaders:{"X-Correlation-ID" :"74feb0c153a14d86baf224b9aab04a4a"}); // Ajout de l'en-tête X-Correlation-ID
  }

  getFormSante(id: any, token: string): Observable<any> {
    const headers = getHeaders()
    return this.http.get(`${environment.MSAggravation}/api/Question/client/${id}`, { headers, params: { token: token } }); // HttpHeaders:{"X-Correlation-ID" :"74feb0c153a14d86baf224b9aab04a4a"}); // Ajout de l'en-tête X-Correlation-ID
  }



  SavePolicy(data: any, token: string): Observable<any> {
    console.log("SavePolicy (Création)")
    const headers = getHeaders();
    return this.http.post<any>(`${environment.MSPolicy}/api/Police/SavePolicy`, data, { headers, params: { token: token } });
  }

  GenerateHTML(data: any, token: string): Observable<string> {
    console.log("GenerateHTML (Création)");
    const headers = getHeaders();
    const url = `${environment.MSAggravation}/api/Evaluation/generate-html`;

    // 1. Le type générique est <string>
    // 2. Le responseType est 'text'
    // 3. Le type de retour de la fonction est Observable<string>
    // Ces trois éléments sont maintenant cohérents.
    return this.http.post<string>(url, data, {
      headers: headers,
      params: { token: token },
      responseType: 'text' as 'json' // Astuce de casting pour contourner un bug de typage strict
    });
  }

  // MISE À JOUR DE CETTE MÉTHODE
  updatePolicy(id: string, data: any, token: string): Observable<any> {
    console.log(`UpdatePolicy (Mise à jour ID: ${id})`)
    const headers = getHeaders();
    return this.http.put<any>(`${environment.MSPolicy}/api/Police/UpdatePolicy/${id}`, data, { headers, params: { token: token } });
  }

  // NOUVELLE MÉTHODE POUR REGROUPER LES APPELS
  loadFormDatasBank(token: string, bankUserId: string): Observable<any> {
    return forkJoin({
      groupProducts: this.getAllBankGroupProducts(token, bankUserId),
      contracts: this.getAllBankProducts(token, bankUserId),
      miniContrat: this.getAllMiniBankProducts(token, bankUserId),
    });
  }

  // NOUVELLE MÉTHODE (pour être appelée par forkJoin)
  getAgencies(token: string): Observable<any[]> {
    const headers = getHeaders();
    return this.http.get<any[]>(`${environment.MSBank}/api/Branch/Get`, { headers, params: { token } });
  }

  // --- MÉTHODE MODIFIÉE POUR TRIER LA RÉPONSE ---
  getAllPoliciesFilter3(
    date_minimum?: string,
    date_maximum?: string,
    policyStatus?: string,
    productCode?: string,
    userWhoNew?: string,
    agencyCode?: string,
    groupPolicyID?: string,
    groupContractID?: string,
    insuredName?: string,
    customerID?: number,
    pageNumber?: number,
    pageSize?: number,
    token?: string
  ): Observable<any> {
    let params = new HttpParams();

    // La construction des paramètres reste inchangée, sans tri demandé au backend.
    if (date_minimum) params = params.set('date_minimum', date_minimum);
    if (date_maximum) params = params.set('date_maximum', date_maximum);
    params = params.set('token', token);
    if (userWhoNew) params = params.set('userWhoCreated', userWhoNew);
    if (productCode) params = params.set('productCode', productCode);
    if (policyStatus) params = params.set('policyStatus', policyStatus);
    if (agencyCode) params = params.set('agencyCode', agencyCode);
    if (groupPolicyID) params = params.set('groupPolicyID', groupPolicyID);
    if (groupContractID) params = params.set('groupContractID', groupContractID);
    if (insuredName) params = params.set('insuredname', insuredName);
    if (pageNumber > 0) params = params.set('pageNumber', pageNumber.toString());
    if (pageSize > 0) params = params.set('pageSize', pageSize.toString());

    console.log('params sent to backend (without sort): ', params.toString());

    const headers = getHeaders();

    // On utilise .pipe() pour transformer la réponse de l'API avant de la retourner
    return this.http.get<any>(`${environment.MSPolicy}/api/Police/GetPolicesFilter`, { headers, params }).pipe(
      map(response => {
        // Vérification de sécurité pour s'assurer que la réponse a la bonne structure
        if (response && Array.isArray(response.items)) {
          // Tri du tableau 'items' par 'CreationDate' en ordre décroissant (plus récent au plus ancien)
          response.items.sort((a, b) => {
            const dateA = new Date(a.CreationDate).getTime();
            const dateB = new Date(b.CreationDate).getTime();
            // Inverser a et b pour un tri descendant
            return dateB - dateA;
          });
        }
        // Retourner la réponse complète, maintenant avec le tableau 'items' trié
        return response;
      })
    );
  }

  getNextContractNumber(token: string, groupContractNumber: string): Observable<any> {
    const url = `${environment.MSPolicy}/api/EnumerationChamp/GetNextContractNumber?groupContractNumber=${groupContractNumber}`; // Assurez-vous que l'URL est correcte
    const headers = getHeaders();
    // let params = new HttpParams();
    // params = params.set('groupContractNumber', groupContractNumber);
    //params = params.set('token', token);

    return this.http.get(url, { headers, params: { token } });
  }

  getEnumerations(token: string): Observable<any> {
    const headers = getHeaders();
    return this.http.get(`${environment.MSPolicy}/api/EnumerationChamp/GetEnumerationList`, { headers, params: { token } });
  }



  /**
   * Récupère les statistiques de polices par banque/agence
   * @param startDate Format: YYYY-MM-DD ou DD/MM/YYYY
   * @param endDate Format: YYYY-MM-DD ou DD/MM/YYYY
   * @param bankIds Liste des IDs de banques/agences (ex: "40,129097")
   * @param token Token d'authentification
   * @returns Observable<any[]> Tableau avec countCreated, countApproved, countTransferred, countPaid, potentialTurnover, expectedTurnover, dueTurnover
   */
  getPoliciesStatistics(startDate: string, endDate: string, bankIds: string, token: string, agencyCode?: string, lastBatchTransfer: boolean = false): Observable<any> {
    const headers = getHeaders();
    const queryParams: any = {
      startDate: startDate,
      endDate: endDate,
      bankIds: bankIds,
      token: token,
      lastBatchTransfer: lastBatchTransfer ? 'true' : 'false'
    };
    if (agencyCode) queryParams.agencyCodes = agencyCode;
    return this.http.get(`${environment.MSPolicy}/api/Police/GetStatistics`, { headers, params: queryParams });
  }
}
